import { Button, Dialog, Input } from "../../../components/ui";

const FeedEditorDialog = ({
  open,
  feed,
  onOpenChange,
  onSubmit,
}: {
  open: boolean;
  feed: any;
  onOpenChange: (open: boolean) => void;
  onSubmit: (values: {
    provider: string;
    name: string;
    url: string;
    active?: boolean;
    categories: string[];
  }) => Promise<void>;
}) => {
  return (
    <Dialog
      open={open}
      onOpenChange={onOpenChange}
      title={feed ? "Edit feed" : "Create feed"}
      description="Keep CRUD inside the workflow surface instead of relying on bootstrap-only management."
      showCloseButton
    >
      <form
        className="flex flex-col gap-4"
        onSubmit={async (event) => {
          event.preventDefault();
          const formData = new FormData(event.currentTarget);
          await onSubmit({
            provider: String(formData.get("provider") || ""),
            name: String(formData.get("name") || ""),
            url: String(formData.get("url") || ""),
            categories: String(formData.get("categories") || "")
              .split(",")
              .map((value) => value.trim())
              .filter(Boolean),
            active: feed?.active ?? true,
          });
        }}
      >
        <Input
          id="provider"
          name="provider"
          label="Provider"
          defaultValue={feed?.provider ?? ""}
          className="rounded-sm"
        />
        <Input
          id="name"
          name="name"
          label="Feed name"
          defaultValue={feed?.name ?? ""}
          className="rounded-sm"
        />
        <Input
          id="url"
          name="url"
          label="Feed URL"
          defaultValue={feed?.url ?? ""}
          className="rounded-sm"
        />
        <Input
          id="categories"
          name="categories"
          label="Categories"
          defaultValue={feed?.categories?.join(", ") ?? ""}
          className="rounded-sm"
        />
        <div className="flex justify-end gap-3">
          <Button
            type="button"
            variant="outline"
            tone="neutral"
            size="sm"
            className="rounded-sm"
            onClick={() => onOpenChange(false)}
          >
            Cancel
          </Button>
          <Button type="submit" tone="primary" size="sm" className="rounded-sm">
            Save feed
          </Button>
        </div>
      </form>
    </Dialog>
  );
};

export default FeedEditorDialog;
